<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M28.694 68.043h3.201l-1.6-4.075zM15.527 65.003c.314-.254.471-.607.471-1.057 0-.45-.157-.81-.471-1.079-.315-.269-.743-.403-1.283-.403h-3.048v2.92h3.048c.54 0 .968-.127 1.283-.381"
      />
      <path
        d="M37.618 59.151h4.407l2.588 9.088 3.201-9.132h3.07l3.201 9.132 2.588-9.088h4.32l-5.131 15.343h-3.465l-3.07-8.936-3.113 8.936h-3.509L37.618 59.15zm1.052 15.256h-4.232l-1.293-3.226h-5.701l-1.294 3.226h-4.166l6.447-15.343h3.793l6.446 15.343zm32.537 19.075H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288V54.29c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.155 61.586c0 2.275-1.858 4.125-4.145 4.125zM11.196 74.407H7.249V59.15h7.214c1.696 0 3.033.443 4.013 1.33 1.008.871 1.513 1.997 1.513 3.377 0 .989-.263 1.86-.79 2.616-.526.755-1.257 1.315-2.192 1.678l4.648 6.255h-4.539l-4.341-5.82h-1.58v5.82zM56.48 0H16.07C10.166 0 5.36 4.78 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.706-4.773 10.706-10.643V25.19L56.48 0z"
      />
      <path
        d="M45.777 28.58a2.406 2.406 0 0 0-1.87.69l-3.095 3.099-7.889-7.842a2.406 2.406 0 0 0-1.703-.715 2.404 2.404 0 0 0-1.726.859l-11.99 14.3a2.374 2.374 0 0 0 .303 3.357c.401.333.901.527 1.423.552h33.573a2.39 2.39 0 0 0 2.398-2.384c0-.515-.169-1.017-.48-1.43l-7.194-9.533a2.401 2.401 0 0 0-1.75-.954M43.21 14.279c2.65 0 4.797 2.134 4.797 4.767 0 2.632-2.148 4.767-4.796 4.767-2.65 0-4.796-2.135-4.796-4.767 0-2.633 2.147-4.767 4.796-4.767"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-raw',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
